import {
  LOAD_QUALIFICATIONS_REQUEST,
  LOAD_QUALIFICATIONS_SUCCESS,
  LOAD_QUALIFICATIONS_FAILURE,
  LOAD_QUALIFICATION_REQUEST,
  LOAD_QUALIFICATION_SUCCESS,
  LOAD_QUALIFICATION_FAILURE,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
  RESET_CURRENT_CAMPAIGN,
  LOAD_DEVELOPER_QUALIFICATIONS_REQUEST,
  LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS,
  LOAD_DEVELOPER_QUALIFICATIONS_FAILURE,
} from '../ActionType';

const initialState = {
  currentTargetingByCountryLanguage: null,
  currentTargetingByCountryLanguageLoading: true,
  currentTargetingByCountryLanguageError: '',

  targetingByCountryLanguage: {},
  targetingByCountryLanguageLoading: true,
  targetingByCountryLanguageError: '',

  currentQualificationById: null,
  currentQualificationByIdLoading: true,
  currentQualificationByIdError: '',

  qualificationsById: {},
  qualificationsByIdLoading: true,
  qualificationsByIdError: '',

  developerQualifications: [],
  developerQualificationsLoading: true,
  developerQualificationsError: '',
};

export const getCurrentQualification = (state) => ({
  data: state.qualification.qualificationsById[
    state.qualification.currentQualificationById
  ],
  loading: state.qualification.currentQualificationByIdLoading,
  error: state.qualification.currentQualificationByIdError,
});

export const getCurrentTargetingByCountryLanguage = (state) => ({
  data:
    state.qualification.currentTargetingByCountryLanguage &&
    state.qualification.targetingByCountryLanguage[
      `${state.qualification.currentTargetingByCountryLanguage.countryId}-${state.qualification.currentTargetingByCountryLanguage.languageId}`
    ],
  loading: state.qualification.currentTargetingByCountryLanguageLoading,
  error: state.qualification.currentTargetingByCountryLanguageError,
});

export const getQualifications = (state) => ({
  data: state.qualification.qualificationsById,
  loading: state.qualification.qualificationsByIdLoading,
  error: state.qualification.qualificationsByIdError,
});

export const getDeveloperQualifications = (state) => ({
  data: state.qualification.developerQualifications,
  loading: state.qualification.developerQualificationsLoading,
  error: state.qualification.developerQualificationsError,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_CURRENT_CAMPAIGN: {
      return {
        ...state,
        currentQualificationByIdLoading: true,
        currentQualificationByIdError: '',
        currentQualificationById: null,
        currentTargetingByCountryLanguage: null,
        currentTargetingByCountryLanguageLoading: true,
        currentTargetingByCountryLanguageError: '',
      };
    }
    case LOAD_QUALIFICATION_REQUEST: {
      const { id } = action.payload;
      return {
        ...state,
        currentQualificationByIdLoading: true,
        currentQualificationByIdError: '',
        currentQualificationById: id,
      };
    }
    case LOAD_QUALIFICATION_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        currentQualificationByIdLoading: false,
        currentQualificationByIdError: error,
      };
    }
    case LOAD_QUALIFICATION_SUCCESS: {
      const { qualification } = action.payload;
      return {
        ...state,
        currentQualificationByIdLoading: false,
        currentQualificationByIdError: '',
        qualificationsById: {
          ...state.qualificationsById,
          [qualification.id]: {
            ...state.qualificationsById[qualification.id],
            ...qualification,
          },
        },
      };
    }
    case LOAD_QUALIFICATIONS_REQUEST: {
      return {
        ...state,
        qualificationsByIdLoading: true,
        qualificationsByIdError: '',
      };
    }
    case LOAD_QUALIFICATIONS_SUCCESS: {
      const { qualifications } = action.payload;
      return {
        ...state,
        qualificationsById: {
          ...state.qualificationsById,
          ...qualifications,
        },
        qualificationsByIdLoading: false,
        qualificationsByIdError: '',
      };
    }
    case LOAD_QUALIFICATIONS_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        qualifications: {
          ...state.qualifications,
          error: error,
        },
        targetingQualifications: {
          ...state.targetingQualifications,
          error: error,
        },
        qualificationsByIdLoading: false,
        qualificationsByIdError: error,
      };
    }
    case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST: {
      const { countryId, languageId } = action.payload;
      return {
        ...state,
        currentTargetingByCountryLanguageLoading: true,
        currentTargetingByCountryLanguageError: '',
        currentTargetingByCountryLanguage: {
          countryId,
          languageId,
        },
      };
    }
    case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS: {
      const { countryId, languageId, targetingQualification } = action.payload;
      return {
        ...state,
        currentTargetingByCountryLanguageLoading: false,
        currentTargetingByCountryLanguageError: '',
        currentTargetingByCountryLanguage: {
          countryId,
          languageId,
        },
        targetingByCountryLanguage: {
          ...state.targetingByCountryLanguage,
          [`${countryId}-${languageId}`]: targetingQualification,
        },
      };
    }
    case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        targetingByCountryLanguageLoading: false,
        targetingByCountryLanguageError: error,
      };
    }

    case LOAD_DEVELOPER_QUALIFICATIONS_REQUEST: {
      return {
        ...state,
        developerQualificationsLoading: true,
        developerQualificationsError: '',
      };
    }
    case LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS: {
      const { qualifications } = action.payload;

      return {
        ...state,
        developerQualificationsLoading: false,
        developerQualificationsError: '',
        developerQualifications: qualifications,
      };
    }
    case LOAD_DEVELOPER_QUALIFICATIONS_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        developerQualificationsLoading: false,
        developerQualificationsError: error,
      };
    }
    default:
      return state;
  }
}
